import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {RmsService, RmsResponse} from '../../../../../projects/jv-common/src/public_api';
import {VOCType, FeeType} from '../enums/all';
import {Observable} from 'rxjs/internal/Observable';
import {
    FeeDTO,
    FeeApplicationInfoDTO,
    FeeApplicationRequestDTO,
    IDNameAddressDTO,
    IDPeriodDTO,
    OneTimeFeeRecordDTO,
    OutletBrandDebtRecordDTO,
    OutletDebtRecordDTO,
    OutletFeeRecordDTO,
    PaymentRecordDTO,
    TransactionRequestDTO,
    VOCDebtRecordDTO,
    VOCUpdateRequestDTO,
    WarehouseDebtRecordDTO,
    PaymentRequestDTO,
    ServicePaymentRecordDTO,
    ServiceUpdateRequestDTO,
    ReconcileDto

} from '../DTO/all';
@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private managersID = {
        '2' : 'AHA',
        '9' :'VOVA',
        // '1379': 'TEST1.RP'
    };
    constructor(
        private rms: RmsService
    ) {
    }

    debtOfOutlets(period: string): Observable<RmsResponse<Array<OutletDebtRecordDTO>>> {

        return this.rms.request<string, Array<OutletDebtRecordDTO>>({
            service: 'pom.accounting.debtofoutlets',
            data: period
        });
    }

    paidToServices(data: PaymentRequestDTO) {

        return this.rms.request<PaymentRequestDTO, Array<ServicePaymentRecordDTO>>({
            service: 'pom.accounting.paidtoservices',
            data: data
        });
    }

    collectFromOutlet(data: TransactionRequestDTO) {

        return this.rms.request<TransactionRequestDTO, boolean>({
            service: 'pom.accounting.collectfromoutlet',
            data: data
        });
    }
    pointsToDebt(data: IDPeriodDTO){
        return this.rms.request<IDPeriodDTO, any>({
            service: 'pom.accounting.pointstodebt',
            data: data
        });
    }
    reconcile(data: ReconcileDto){
        return this.rms.request<ReconcileDto, any>({
            service: 'pom.accounting.reconcile',
            data: data
        });
    }
    collectedFromOutlets(data: PaymentRequestDTO) {

        return this.rms.request<PaymentRequestDTO, Array<PaymentRecordDTO>>({
            service: 'pom.accounting.collectedfromoutlets',
            data: data
        });
    }

    debtToVendors(period: string) {

        return this.rms.request<string, Array<VOCDebtRecordDTO>>({
            service: 'pom.accounting.debttovendors',
            data: period
        });
    }

    payToVendor(data: TransactionRequestDTO) {

        return this.rms.request<TransactionRequestDTO, boolean>({
            service: 'pom.accounting.paytovendor',
            data: data
        });
    }

    payToService(data: TransactionRequestDTO) {
        return this.rms.request<TransactionRequestDTO, boolean>({
            service: 'pom.accounting.paytoservice',
            data: data
        });
    }

    paidToVendors(data: PaymentRequestDTO) {

        return this.rms.request<PaymentRequestDTO, Array<PaymentRecordDTO>>({
            service: 'pom.accounting.paidtovendors',
            data: data
        });
    }

    debtToVendor(data: IDPeriodDTO) {

        return this.rms.request<IDPeriodDTO, Array<WarehouseDebtRecordDTO>>({
            service: 'pom.accounting.debttovendor',
            data: data
        });
    }

    debtOfCustomers(period: string) {

        return this.rms.request<string, Array<VOCDebtRecordDTO>>({
            service: 'pom.accounting.debtofcustomers',
            data: period
        });
    }

    collectFromCustomer(data: TransactionRequestDTO) {

        return this.rms.request<TransactionRequestDTO, boolean>({
            service: 'pom.accounting.collectfromcustomer',
            data: data
        });
    }

    debtOfCustomer(data: IDPeriodDTO) {

        return this.rms.request<IDPeriodDTO, Array<WarehouseDebtRecordDTO>>({
            service: 'pom.accounting.debtofcustomer',
            data: data
        });
    }

    /* Edit INFO */
    updateVOC(data: VOCUpdateRequestDTO) {

        return this.rms.request<VOCUpdateRequestDTO, boolean>({
            service: 'pom.voc.update',
            data: data
        });
    }

    updateService(data: ServiceUpdateRequestDTO) {
        return this.rms.request<ServiceUpdateRequestDTO, boolean>({
            service: 'pom.service.update',
            data: data
        });
    }

    createTurnOver(data: IDPeriodDTO) {

        return this.rms.request<IDPeriodDTO, boolean>({
            service: 'pom.turnover.create',
            data: data
        });
    }

    deleteTurnOver(data: IDPeriodDTO) {

        return this.rms.request<IDPeriodDTO, boolean>({
            service: 'pom.turnover.delete',
            data: data
        });
    }

    feeCreate(data: FeeDTO) {

        return this.rms.request<FeeDTO, FeeDTO>({
            service: "pom.fee.create",
            data: data
        });
    }

    feeUpdate(data: FeeDTO) {

        return this.rms.request<FeeDTO, boolean>({
            service: "pom.fee.update",
            data: data
        });
    }


    feeInfo(id: number) {

        return this.rms.request<number, Array<FeeApplicationInfoDTO>>({
            service: "pom.fee.info",
            data: id
        });
    }

    feeList() {

        return this.rms.request<string, { Fees: Array<FeeDTO>, Capitals: Array<IDNameAddressDTO> }>({
            service: "pom.fee.list",
            data: ''
        });
    }

    feeAdd(data: FeeApplicationInfoDTO) {

        return this.rms.request<FeeApplicationInfoDTO, FeeApplicationInfoDTO>({
            service: "pom.fee.add",
            data: data
        });
    }

    feeRemove(data: FeeApplicationInfoDTO) {

        return this.rms.request<FeeApplicationInfoDTO, boolean>({
            service: "pom.fee.remove",
            data: data
        });
    }

    feeApply(data: FeeApplicationRequestDTO) {

        return this.rms.request<FeeApplicationRequestDTO, boolean>({
            service: "pom.fee.apply",
            data: data
        });
    }

    debtOfOutlet(data: IDPeriodDTO) {

        return this.rms.request<IDPeriodDTO, Array<OutletBrandDebtRecordDTO>>({
            service: 'pom.accounting.debtofoutlet',
            data: data
        });
    }

    depositOfOutlet(data: number) {
        return this.rms.request<number, Array<PaymentRecordDTO>>({
            service: 'pom.accounting.depositofoutlet',
            data: data
        });
    }

    depositToVendor(data: number) {
        return this.rms.request<number, Array<PaymentRecordDTO>>({
            service: 'pom.accounting.deposittovendor',
            data: data
        });
    }

    depositToDebt(data: IDPeriodDTO) {
        return this.rms.request<IDPeriodDTO, boolean>({
            service: 'pom.accounting.deposittodebt',
            data: data
        });
    }

    feeOfOutlets() {

        return this.rms.request<string, Array<OutletFeeRecordDTO>>({
            service: 'pom.accounting.feeofoutlets',
            data: ''
        });
    }

    collectedFromGateways(period: string) {
        return this.rms.request<any, any>({
            service: 'pom.accounting.collectedfromgateways',
            data: {
                Period: period
            }
        });
    }

    /* AHA POINTS */
    pointHistory(period: string) {
        return this.rms.request<any, any>({
            service: 'pom.accounting.pointhistory',
            data: period
        });
    }
    general(period: string){
        return this.rms.request<any, any>({
            service: 'pom.accounting.general',
            data: period
        });
    }
    isManager(){
        let user = this.rms.getUser();
        return user && typeof this.managersID[user.ID] !== "undefined";
    }
    pendingIEs(data){
        return this.rms.request({service: 'pom.accounting.pendingIEs', data: data})
    }
    // Ice Cream Ws

    pomPublicIOPull(id = 0){
        return this.rms.request({
            service: 'pom.public.io.pull',
            data: id
        });
    }
    pomTransferInfo(data:any){
        return this.rms.request({
            service: 'pom.transfer.info',
            data: data
        });
    }
    pomWarehousesTransfer(data: any){
        return this.rms.request({
            service: 'pom.warehouses.transfer',
            data: data
        })
    }
}
